import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import IconDelete from "@material-ui/icons/Delete";
import GroupIcon from "@material-ui/icons/Group";
import IconPublish from "@material-ui/icons/Publish";

import PropTypes from "prop-types";
import React, { useState } from "react";

import GroupSelector from "@components/GroupSelector";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  list: {
    padding: "0px !important",
  },
  listItem: {
    border: "1px solid #c4c4c4",
    borderRadius: "4px",
    paddingTop: "7px",
    paddingBottom: "7px",
  },
  empty: {
    color: "rgba(0, 0, 0, 0.54)",
  },
  activeAvatar: {
    backgroundColor: "#3f51b5",
  },
}));

function GroupItem(props) {
  const classes = useStyles();

  function handleSelect() {
    props.onSelect();
  }

  function handleDelete() {
    props.onDelete();
  }

  return (
    <ListItem className={classes.listItem}>
      {props.icon && (
        <ListItemAvatar>
          <Avatar className={props.group ? classes.activeAvatar : ""}>
            <GroupIcon />
          </Avatar>
        </ListItemAvatar>
      )}

      {!props.group && (
        <ListItemText
          className={classes.empty}
          primary="Nenhum grupo selecionado"
        />
      )}

      {props.group && <ListItemText primary={props.group.name} />}

      {props.group && (
        <ListItemSecondaryAction>
          <IconButton onClick={handleSelect} aria-label="update">
            <IconPublish />
          </IconButton>
          <IconButton onClick={handleDelete} edge="end" aria-label="delete">
            <IconDelete />
          </IconButton>
        </ListItemSecondaryAction>
      )}

      {!props.group && (
        <div>
          <Button variant="contained" color="primary" onClick={handleSelect}>
            Selecionar
          </Button>
        </div>
      )}
    </ListItem>
  );
}

GroupItem.propTypes = {
  group: PropTypes.object,
  icon: PropTypes.bool,
  onSelect: PropTypes.func,
  onDelete: PropTypes.func,
};

GroupItem.defaultProps = {
  group: null,
  icon: true,
  onSelect: () => {},
  onDelete: () => {},
};

function GroupInput(props) {
  const classes = useStyles();

  const [dense] = useState(false);
  const [activeSelector, setActiveSelector] = useState(false);

  function handleCloseSelector() {
    setActiveSelector(false);
  }

  function handleSelect(group) {
    setActiveSelector(false);
    props.onChange(group);
  }

  function handleDelete() {
    props.onChange(null);
  }

  function handleUpdate() {
    setActiveSelector(true);
  }

  return (
    <div className={classes.root}>
      <List dense={dense} className={classes.list}>
        <GroupItem
          group={props.group}
          icon={props.icon}
          onSelect={handleUpdate}
          onDelete={handleDelete}
        />
      </List>
      <GroupSelector
        show={activeSelector}
        onClose={handleCloseSelector}
        onSelect={handleSelect}
      />
    </div>
  );
}

GroupInput.propTypes = {
  group: PropTypes.object,
  icon: PropTypes.bool,
  onChange: PropTypes.func,
};

GroupInput.defaultProps = {
  group: null,
  icon: true,
  onChange: () => {},
};

export default GroupInput;
